module.exports = __webpack_public_path__ + "img/type--2-spans--single-lang--es.4c31a202.jpg";